import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiPath } from "../../services/apiPath";
import authService from "../../services/authService";
import newJobOfferApi from "../../services/newJobOfferApi";

export const getFlexibleDate = createAsyncThunk(
  "jobOfferDropdowns/getFlexibleDate",
  async (thunkAPI) => {
    try {
      const data = await newJobOfferApi.getJobOfferDropdownItems(
        apiPath.getFlexibleDate
      );
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getMainDuties = createAsyncThunk(
  "jobOfferDropdowns/getMainDuties",
  async (thunkAPI) => {
    try {
      const data = await newJobOfferApi.getJobOfferDropdownItems(
        apiPath.employer_duties
      );
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getJobSkills = createAsyncThunk(
  "jobOfferDropdowns/getJobSkills",
  async (thunkAPI) => {
    try {
      const data = await newJobOfferApi.getJobOfferDropdownItems(
        apiPath.employerMainSkills
      );
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getCookings = createAsyncThunk(
  "jobOfferDropdowns/getCookings",
  async (thunkAPI) => {
    try {
      const data = await newJobOfferApi.getJobOfferDropdownItems(
        apiPath.employerCookingList
      );
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getLanguages = createAsyncThunk(
  "jobOfferDropdowns/getLanguages",
  async (thunkAPI) => {
    try {
      const data = await newJobOfferApi.getJobOfferDropdownItems(
        apiPath.employerSpokenLanguage
      );
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getSpecialCourses = createAsyncThunk(
  "jobOfferDropdowns/getSpecialCourses",
  async (thunkAPI) => {
    try {
      const data = await newJobOfferApi.getJobOfferDropdownItems(
        apiPath.employerSpecialCourses
      );
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getHelperNationality = createAsyncThunk(
  "jobOfferDropdowns/getHelperNationality",
  async (thunkAPI) => {
    try {
      const data = await newJobOfferApi.getJobOfferDropdownItems(
        apiPath.employerNationality
      );
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getMinimumEducation = createAsyncThunk(
  "jobOfferDropdowns/getMinimumEducation",
  async (thunkAPI) => {
    try {
      const data = await newJobOfferApi.getJobOfferDropdownItems(
        apiPath.employerEducation
      );
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getCurrentLocation = createAsyncThunk(
  "jobOfferDropdowns/getCurrentLocation",
  async (thunkAPI) => {
    try {
      const data = await newJobOfferApi.getJobOfferDropdownItems(
        apiPath.employerLocationList
      );
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getMaritalStatus = createAsyncThunk(
  "jobOfferDropdowns/getMaritalStatus",
  async (thunkAPI) => {
    try {
      const data = await newJobOfferApi.getJobOfferDropdownItems(
        apiPath.employerMaritalStatus
      );
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//getContractStatus
export const getContractStatus = createAsyncThunk(
  "jobOfferDropdowns/getContractStatus",
  async (thunkAPI) => {
    try {
      const data = await newJobOfferApi.getJobOfferDropdownItems(
        apiPath.empoyerContractStatus
      );
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//getReligion
export const getReligion = createAsyncThunk(
  "jobOfferDropdowns/getReligion",
  async (thunkAPI) => {
    try {
      const data = await newJobOfferApi.getJobOfferDropdownItems(
        apiPath.workerReligion
      );
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//getEmployerNationality
export const getEmployerNationality = createAsyncThunk(
  "jobOfferDropdowns/getEmployerNationality",
  async (thunkAPI) => {
    try {
      const data = await newJobOfferApi.getJobOfferDropdownItems(
        apiPath.employerNationality
      );
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//getAccomodation
export const getAccomodation = createAsyncThunk(
  "jobOfferDropdowns/getAccomodation",
  async (thunkAPI) => {
    try {
      const data = await newJobOfferApi.getJobOfferDropdownItems(
        apiPath.getAccommodation
      );
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//getDayOff
export const getDayOff = createAsyncThunk(
  "jobOfferDropdowns/getDayOff",
  async (thunkAPI) => {
    try {
      const data = await newJobOfferApi.getJobOfferDropdownItems(
        apiPath.getDayOffList
      );
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//get-expected-salary
export const getExpectedSalary = createAsyncThunk(
  "jobOfferDropdowns/getExpectedSalary",
  async (thunkAPI) => {
    try {
      const data = await newJobOfferApi.getJobOfferDropdownItems(
        apiPath.getExpectedSalary
      );
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getInterviewLocations = createAsyncThunk(
  "jobOfferDropdowns/getInterviewLocations",
  async (thunkAPI) => {
    try {
      const data = await newJobOfferApi.getJobOfferDropdownItems(
        apiPath.getInterviewLocations
      );
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getJobWorkerList = createAsyncThunk(
  "jobOfferDropdowns/getJobWorkerList",
  async (params, thunkAPI) => {
    try {
      const data = await newJobOfferApi.getJobWorkerListApi(params);
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getJobStages = createAsyncThunk(
  "jobOfferDropdowns/getJobStages",
  async (thunkAPI) => {
    try {
      const data = await newJobOfferApi.getJobStagesApi();
      return { response: data };
    } catch (error) {
      if (error.response.data.is_logged_out) {
        authService.logout();
      }
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const initialState = {
  flexibleDates: [],
  mainDuties: [],
  jobSkills: [],
  cooking: [],
  languages: [],
  specialCourses: [],
  helperNationalities: [],
  minEducation: [],
  currentLocation: [],
  maritalStatus: [],
  contractStatus: [],
  religions: [],
  employerNationalities: [],
  accomodations: [],
  dayOffs: [],
  expectedSalaries: [],
  interviewLocations: [],
  jobofferWorkerList: [],
  jobStages: [],
};

const jobOfferDetailsSlice = createSlice({
  name: "jobOfferDetails",
  initialState,
  extraReducers: {
    [getFlexibleDate.fulfilled]: (state, action) => {
      state.flexibleDates = action.payload.response.data;
    },
    [getMainDuties.fulfilled]: (state, action) => {
      state.mainDuties = action.payload.response.data;
    },
    [getJobSkills.fulfilled]: (state, action) => {
      state.jobSkills = action.payload.response.data;
    },
    [getCookings.fulfilled]: (state, action) => {
      state.cooking = action.payload.response.data;
    },
    [getLanguages.fulfilled]: (state, action) => {
      state.languages = action.payload.response.data;
    },
    [getSpecialCourses.fulfilled]: (state, action) => {
      state.specialCourses = action.payload.response.data;
    },
    [getHelperNationality.fulfilled]: (state, action) => {
      state.helperNationalities = action.payload.response.data;
    },
    [getMinimumEducation.fulfilled]: (state, action) => {
      state.minEducation = action.payload.response.data;
    },
    [getCurrentLocation.fulfilled]: (state, action) => {
      state.currentLocation = action.payload.response.data;
    },
    [getMaritalStatus.fulfilled]: (state, action) => {
      state.maritalStatus = action.payload.response.data;
    },
    [getContractStatus.fulfilled]: (state, action) => {
      state.contractStatus = action.payload.response.data;
    },
    [getReligion.fulfilled]: (state, action) => {
      state.religions = action.payload.response.data;
    },
    [getEmployerNationality.fulfilled]: (state, action) => {
      state.employerNationalities = action.payload.response.data;
    },
    [getAccomodation.fulfilled]: (state, action) => {
      state.accomodations = action.payload.response.data;
    },
    [getDayOff.fulfilled]: (state, action) => {
      state.dayOffs = action.payload.response.data;
    },
    [getExpectedSalary.fulfilled]: (state, action) => {
      state.expectedSalaries = action.payload.response.data;
    },
    [getInterviewLocations.fulfilled]: (state, action) => {
      if (state.interviewLocations.length === 1) {
        state.interviewLocations.push(...action.payload.response.data);
      } else {
        state.interviewLocations = [{ id: 0, name: "All Locations" }];
        state.interviewLocations.push(...action.payload.response.data);
      }
    },
    [getJobWorkerList.fulfilled]: (state, action) => {
      state.jobofferWorkerList = action.payload.response.data;
    },
    [getJobWorkerList.rejected]: (state) => {
      state.jobofferWorkerList = [];
    },
    [getJobStages.fulfilled]: (state, action) => {
      if (state.jobStages.length === 1) {
        state.jobStages.push(...action.payload.response.data);
      } else {
        state.jobStages = [{ id: 0, name: "All" }];
        state.jobStages.push(...action.payload.response.data);
      }
    },
    [getJobStages.rejected]: (state) => {
      state.jobStages = [];
    },
  },
});

const { reducer } = jobOfferDetailsSlice;
export default reducer;
